import React, { useEffect, useState } from 'react'
import { AutoComplete, Input } from 'antd'
import { get } from '../../Common/api'
import { Color } from '../../Common/Color'

const highlight = (text, highlight) => {
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'))
  return <span> {parts.map((part, i) =>
    <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { color: Color.red } : {}}>
      {part}
    </span>)
  } </span>
}

const renderItem = (e, search) => ({
  value: `${e.normalized_name} ${e.zip_code}`,
  key: e.id,
  extra: e,
  label: (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {highlight(e.normalized_name, search)}
      <span> {highlight(e.zip_code, search)} </span>
    </div>
  )
})

export default function ZipCodeSearchField ({ form, defaultValue = null }) {
  const [options, setOptions] = useState([])

  useEffect(() => {
    if (defaultValue) {
      handleSearch(defaultValue.zip_code)
    }
  }, [defaultValue])

  const handleSearch = (search, callback) => {
    get('public/postal_places', { search }, (json) => {
      const newOptions = json.map((e) => renderItem(e, search))
      setOptions(newOptions)
      if (callback) {
        callback(json)
      }
    })
  }

  const onSelect = (value) => {
    const option = options.find((o) => o.value === value)
    form.setFieldValue('postal_place_id', option.extra.id)
  }

  return (
    <>
      <AutoComplete
        style={{ minWidth: '13.7em' }}
        dropdownMatchSelectWidth={350}
        options={options}
        onSearch={handleSearch}
        onSelect={onSelect}
        defaultValue={defaultValue ? renderItem(defaultValue, '') : defaultValue}
      />
      <Input type='hidden' />
    </>
  )
}
